<template>
  <gh-table-page ref="table" :tabs="tabs" :show-tabs="true" :args-query="args" :template-model="template"
    module="mes.business.mdl.routing.service" cls="RoutingService" @viewItem="viewItem">
    <template #area_left>
      <gh-business-tree ref="tree" :show-toolbar="false" v-model="curentMaterialType"
        module="mes.business.mdl.material.service" cls="MaterialTypeService">
        <template v-slot="{node,data}">
          {{data.Cd}} {{data.Name}}
        </template>
      </gh-business-tree>
    </template>

    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
    <template #model-prop-File="{prop,model}">

      <gh-upload v-model="model.File"></gh-upload>
    </template>
    <template #area_detail>
      <gh-pdf :id="current.File"></gh-pdf>
    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Routing from "./routing.ts";
  export default Routing;
</script>